export default {
  cancelOrderMap: {
    0: "Saya tidak mahu.",
    1: "Tersalah letak produk",
    2: "Pesanan pendua",
    3: "Terima gagal",
    4: "Sebab lain",
  },
  "电商批发商场": "Pasar borong e-dagang",
  "获取验证码": "Mendapatkan kod semula",
  "请输入验证码": "Sila masukkan kod semula",
  "验证码": "Kod semula",
  "发送": "Menghantar",
  "已发送，请注意查收":
    "Terkirim, perhatikan penghantaran",
  "当前余额": "Baki semasa",
  "请选择": "Sila pilih",
  "绑定成功": "Berjaya diikat",
  "仅能绑定一个收款地址!": "Hanya satu alamat penerimaan boleh diikat!",
  "提款地址绑定": "Alamat pengeluaran",
  "请输入完整的支付密码!" : "Sila masukkan kata laluan pembayaran yang lengkap!",
  "用户未发表评论": "Pengguna belum mengulas",
  "订单": "Pesanan",
  "备注": "Catatan",
  "下单成功，等待付款": "Pesanan berjaya dibuat, menunggu pembayaran",
  "下单成功，付款成功": "Pesanan berjaya dibuat, pembayaran berjaya",
  "已发货，正在运输中": "Dihantar, dalam pengangkutan",
  "订单已取消，原因:手动发起取消订单": "Pesanan telah dibatalkan. Sebab: Batalkan pesanan secara manual.",
  "订单已取消，原因:超时自动取消订单": "Pesanan telah dibatalkan. Sebab: Pesanan akan dibatalkan secara automatik apabila tamat masa.",
  "商家已确认，已进入备货状态": "Peniaga telah disahkan dan telah memasuki keadaan stok.",
  "系统发货成功": "Penghantaran sistem berjaya",
  "订单已签收": "Pesanan Diterima",
  "发起退款申请": "Mulakan permintaan bayaran balik",
  "退款成功": "Bayaran balik berjaya",
  "退款失败": "Bayaran balik gagal",
  "订单退款成功": "Bayaran balik pesanan berjaya",
  "订单退款失败": "Bayaran balik pesanan gagal",
  "系统默认好评": "Sistem lalai kepada ulasan yang menggalakkan",
  "请输入关键字搜索": "Sila masukkan kata kunci untuk mencari",
  "猜你喜欢": "Rasanya anda suka",
  "订单已完成": "Tempahan selesai",
  "热销推荐": "Cadangan Jualan Panas",
  "头像选择": "Pilihan Avatar",
  "修改头像": "Ubah suai avatar anda",
  subOrder: "Hantar pesanan",
  "mailboxCheck": "Sila isikan alamat e-mel yang betul",
  "switchLang": "Sila tukar kepada bahasa lain untuk melihat",
  "myCart": "Troli beli-belah saya",
  "notQua": "Syarat kelayakan tidak dipenuhi.",
  "noSmaller": "Amaun yang digunakan tidak boleh kurang daripada",
  "nomax": "Jumlah maksimum permohonan tidak boleh melebihi",
  "evaluationUploading": "Anda masih mempunyai gambar yang dimuat naik. Sila cuba sebentar lagi",
  "evaluateInput": "Semak dengan gambar",
  "moneyOrderStatus": "Status pesanan",
  "coinBlock": "Perjanjian mata wang",
  "dealing": "Dalam proses",
  "dealSuccess": "Berjaya",
  "dealFail": "gagal",
  "payCertificate": "Sijil pembayaran",
  "handleFee": "Caj perkhidmatan",
  "highOpinion": "Ulasan yang baik",
  "mediumOpinion": "Kajian sederhana",
  "lowOpinion": "Ulasan buruk",
  "hasImage": "Dengan gambar",
  "rechargeMethod": "Mod cas semula",
  "scanAndDown": "Imbas Kod QR Muat Turun APP",
  "receivedAddress": "Alamat resit",
  "ActualLedger": "Resit sebenar",
  "view": "Lihat",
  "withdrawNum": "Kuantiti pengeluaran tunai",
  "rechargeNum": "Kuantiti cas semula",
  "date": "Tarikh",
  "walletHistory": "Sejarah dompet",
  "accountBalance": "Baki akaun",
  "accountReview": "Gambaran keseluruhan akaun",
  "rated": "Disemak",
  "receiver": "Penerima",
  "orderStatus": "Status",
  "orderTime": "Masa",
  "tax": "percukaian",
  "discount": "Diskaun",
  "productInfo": "Informasi produk",
  "paramError": "Ralat parameter",
  "orderInfo": "Maklumat pesanan",
  "rebuy": "Satu pesanan lagi",
  "pleaseCorrectAddress": "Sila masukkan alamat pengeluaran tunai yang betul",
  "pleaseInputCorrectNumber": "Sila masukkan nombor yang lebih besar daripada 0",
  "vcodePass": "Pengesahan lulus!",
  "vcodeFail": "Pengesahan gagal, sila cuba lagi",
  "uploading": "Memuat naik...",
  "uploadSuccess": "Berjaya dimuat naik",
  "uploadError": "Muatnaik gagal. Sila cuba lagi",
  "registerSuccess": "Daftar berjaya",
  "pleaseSetMobileNumber": "Sila tetapkan nombor telefon",
  "unSelectedProduct": "Anda belum memilih produk",
  "loginSuccess": "Log masuk berjaya",
  "pleaseSetAreaCode": "Masukkan nama negara dan kod kawasan untuk mencari",
  "login": "Log masuk",
  "register": "Pendaftaran",
  "logout": "Keluar",
  "noData": "Tiada data dijumpai",
  "search": "Cari",
  "historySearch": "Pencarian sejarah",
  "empty": "kosong",
  "home": "Laman utama",
  "favorableRate": "Kadar ulasan yang baik",
  "classification": "kategori",
  "searchTips": "Carian sumber/produk/pembekal/pesanan",
  "dailyNewArrival": "Produk baharu harian disenaraikan",
  "more": "Lagi",
  "recommend": "Syor",
  "recommendedProducts": "Produk yang disyorkan",
  "recommendedStore": "Kedai yang disyorkan",
  "buyNow": "Beli sekarang",
  "addCart": "Tambahkan pada troli beli-belah",
  "complex": "Bersepadu",
  "price": "harga",
  "retailPrice": "Harga runcit",
  "originPrice": "Harga asal",
  "service": "Khidmat Pelanggan",
  "collect": "Kegemaran",
  "sold": "Jumlah Jualan",
  "pageviews": "Jumlah pelayaran",
  "quantity": "Kuantiti",
  "freight": "kargo",
  "shipping": "penghantaran",
  "ship": "bot",
  "buyTips": "Hantar dalam masa 24 jam selepas membuat pesanan. Pesanan berikut adalah di bawah kawalan logistik dan mungkin dihantar lewat. Sila beri perhatian kepada maklumat logistik atau hubungi perkhidmatan pelanggan.",
  "totalPrice": "Harga keseluruhan",
  "addCartMessage": "Berjaya ditambahkan pada troli beli-belah",
  "addCartMessageFaild": "Produk sudah wujud dalam troli beli-belah.",
  "myAccount": "akaun q saya",
  "buyHistory": "Rekod pembelian",
  "wishlist": "Produk kegemaran",
  "trackOrder": "Pesanan",
  "account": "Akaun:",
  "sellerZone": "Kawasan peniaga",
  "beSeller": "Menjadi seorang peniaga",
  "sellerPanelLogin": "Log masuk pedagang",
  "footTip": "© Hak Cipta {name} Ltd 2024",
  "footTips": "{name} Limited diberi kuasa dan dikawal oleh Pihak Berkuasa Kelakuan Kewangan sebagai broker kredit (713206) dan berurusan secara eksklusif dengan pemberi pinjaman Home Retail Group CardServices Limited sebagai {name} Financial Services. Perkhidmatan Kewangan {name} diberi kuasa dan dikawal oleh Pihak Berkuasa Kelakuan Kewangan untuk memberikan kredit (716148). Home Retail GroupCard Services Limited didaftarkan di United Kingdom (04007072) di Avebury, 489-499 Avebury Boulevard, Milton Keynes, United Kingdom. MK9 2NW.",
  "item": "Artikel",
  "checkout": "Membuat pesanan",
  "productDescription": "Penerangan Produk",
  "userEvaluation": "Ulasan pengguna",
  "AllProducts": "Semua produk",
  "followers": "Ikut",
  "sales": "Jumlah Jualan",
  "visitStore": "Lawati kedai",
  "authentic": "100% tulen",
  "dayReturns7": "7 hari balik",
  "shippingDiscounts": "Diskaun pengangkutan",
  "safePayment": "Pembayaran Selamat",
  "followed": "Diikuti",
  "dashboard": "Panel Instrumen",
  "myOrder": "Arahan saya",
  "setUp": "Persediaan",
  "successTips": "Berjaya",
  "copySuccess": "Replikasi berjaya",
  "balance": "Baki(USDT)",
  "sort": "taip",
  "commodity": "produk",
  "browse": "Jumlah Jualan",
  "recharge": "Isi semula",
  "commodityCollection": "Koleksi produk",
  "withdraw": "Pengeluaran tunai",
  "defaultAddress": "Alamat lalai",
  "addNewAddress": "Tambah alamat baharu",
  "withdrawRecord": "Rekod pengeluaran tunai",
  "serialNumber": "Pesanan No.",
  "time": "Masa",
  "amount": "Jumlah",
  "processing": "Dalam proses",
  "fail": "gagal",
  "blockchainNetwork": "Rangkaian rantaian blok",
  "records": "Rekod",
  "withdrawAddress": "Alamat pengeluaran tunai",
  "withdrawInputTips": "Sila masukkan alamat pengeluaran",
  "copy": "Replikasi",
  "enterTips": "Sila masukkan",
  "actualAccount": "Akaun sebenar",
  "handlingFee": "Caj perkhidmatan",
  "confirm": "Sahkan resit",
  "previous": "Langkah sebelumnya",
  "pleaseEnterAddress": "Sila masukkan alamat",
  "pleaseEnterQuantity": "Sila masukkan kuantiti",
  "withdrawSuccess": "Pesanan berjaya dihantar",
  "saveQr": "Simpan kod QR",
  "pleaseEnterAmount": "Sila masukkan jumlah caj semula",
  "expectedArrival": "Ketibaan yang dijangkakan",
  "currentRate": "Kadar pertukaran semasa",
  "uploadTips": "Bukti pembayaran (Muat naik tangkapan skrin butiran pembayaran)",
  "clickUpload": "Klik untuk memuat naik",
  "uploadPhoto": "Sila muat naik foto",
  "rechargeSuccessful": "Caj semula berjaya",
  "rechargeTips": "\"Gesaan pengecasan semula: \"\"Sila isikan jumlah pemindahan sebenar dengan jujur. Jika tidak, sistem mungkin gagal lulus kelulusan dan menjejaskan kemajuan pengecasan semula.\"",
  "rechargeRecord": "Rekod cas semula",
  "all": "Semua",
  "pending": "Untuk dibayar",
  "cancelled": "Dibatalkan",
  "delivered": "Untuk dihantar",
  "confirmed": "Disahkan",
  "receipt": "Untuk diterima",
  "harvested": "Menerima",
  "comment": "Untuk disemak",
  "refund": "Bayaran balik/selepas jualan",
  "cancelOrder": "Batalkan pesanan",
  "cancelReason": "Sebab pembatalan",
  "cancelOrderTitle": "Sila pilih sebab pembatalan pesanan",
  "returnOrderTitle": "Sila pilih sebab pulangan",
  "refundInstructions": "Arahan bayaran balik",
  "returnDetailTips": "Sila beri ulasan tentang produk",
  "cancel": "Batalkan pesanan",
  "cancelOrder1": "Produk tidak diterima",
  "cancelOrder2": "Tidak suka, tidak mahu",
  "cancelOrder3": "Penjual tersalah hantar barang",
  "cancelOrder4": "Jenama palsu",
  "cancelOrder5": "Kurang penghantaran, terlepas penghantaran",
  "cancelOrder6": "Produk diterima rosak",
  "cancelOrder7": "Ada masalah kualiti",
  "cancelOrder8": "Rundingkan bayaran balik dengan peniaga",
  "cancelOrder9": "Sebab lain",
  "cancelOrderSuccess": "Pesanan berjaya dibatalkan",
  "returnOrderSuccess": "Hantar berjaya",
  "orderName": "Nama",
  "orderEmail": "E-mel",
  "orderAddress": "Alamat",
  "orderNation": "Negara",
  "orderState": "Status",
  "orderCity": "Bandar",
  "orderPostCode": "Poskod",
  "orderAmount": "Kuantiti",
  "orderPrefix": "Jumlah pesanan",
  "orderFee": "Cukai",
  "orderSpecification": "Spesifikasi",
  "orderCommodity": "produk",
  "orderQuantity": "Kuantiti",
  "orderUnitprice": "Harga seunit",
  "orderFreight": "kargo",
  "orderTax": "Cukai",
  "orderTotal": "Jumlah",
  "PaymentOrder": "Pesanan pembayaran",
  "Evaluate": "Semakan",
  "CancelOrder": "Batalkan pesanan",
  "RemindShip": "Ingatkan untuk Penghantaran",
  "Refund": "Bayaran balik",
  "Submitareview": "Hantar ulasan",
  "Information": "Maklumat",
  "wrongPassword": "Ralat kata laluan lebih daripada 3 kali. Sila cuba lagi esok.",
  "Operate": "Operasi",
  "Item": "Item (s)",
  "From": "daripada",
  "hint": "Petua",
  "CheckDetails": "Lihat butiran",
  "Payment": "Bayaran",
  "Cancel": "Batal",
  "refundSuccessfully": "Bayaran balik berjaya",
  "pendingPayment": "Untuk dibayar",
  "pay": "Bayaran",
  "LoginPassword": "Kata laluan log masuk",
  "sure": "Sudah tentu",
  "shippingAddress": "Menerima alamat",
  "pleaseAddShippingAddress": "Sila tambahkan alamat penghantaran terlebih dahulu",
  "transactionPassword": "Kata laluan transaksi",
  "markDefaultAddress": "Tandai sebagai alamat penghantaran lalai",
  "edit": "Diedit oleh",
  "delete": "Padam",
  "Opt": "Pilih",
  "piece": "Pcs",
  "orderDetails": "Maklumat pesanan",
  "shopCollection": "Tambahkan kedai ke kegemaran",
  "addAddress": "Tambah alamat baharu",
  "signUp": "Pendaftaran",
  "loginTips": "Sudah mempunyai akaun?",
  "loginIn": "Log masuk",
  "mobile": "No telefon",
  '购物车还没有商品': "Troli beli-belah anda kosong",
  '去购物': "Mulakan membeli-belah",
  "modifyAddress": "Ubah suai alamat",
  "desc": "Tetapkan sebagai alamat lalai",
  "keep": "Kekalkan",
  "onlineService": "Perkhidmatan dalam talian",
  "send": "Hantar",
  "EsShop": "Kedai atas talian",
  "desc3": "Masukkan kata laluan transaksi",
  "desc4": "Masukkan kata laluan transaksi anda",
  "desc6": "Masukkan kata laluan transaksi anda sekali lagi",
  "setUpPayPaw": "Tetapkan kata laluan transaksi",
  "setSuccess": "Persediaan berjaya",
  "confirmPayPaw": "Sahkan kata laluan transaksi",
  "paymentSuccessful": "Pembayaran berjaya",
  "paymentPending": "Pembayaran Tertangguh",
  "paymentPendingDesc": "Pembayaran anda sedang diproses. Sila semak status pesanan anda nanti",
  "desc5": "Alamat penghantaran salah? Kenalan",
  "customeService": "Perkhidmatan pelanggan dalam talian",
  "BackHome": "Kembali ke halaman utama",
  "Checkorder": "Lihat Pesanan",
  "ForgotPassword": "Lupa kata laluan?",
  "signIn": "Log masuk",
  "noAccount": "Tiada nombor akaun?",
  "pleaseEnterAccount": "Sila masukkan nombor akaun",
  "pleaseEnterPassword": "Sila masukkan kata laluan",
  "password": "Kata laluan",
  "mobilePhone": "Nombor telefon",
  "pleaseEnterPhoneNumer": "Sila tetapkan nombor telefon",
  "setPassword": "Tetapkan kata laluan",
  "noDataFound": "Tiada data dijumpai",
  "searchCountry": "Masukkan nama negara dan kod kawasan untuk mencari",
  "pleaseEnterEmail": "Sila tetapkan peti mel",
  "invitationCode": "Kod Jemputan",
  "plaeseEnterInvitaionCode": "Sila tetapkan kod jemputan",
  "pleaseSetLoginPassword": "Sila tetapkan kata laluan log masuk",
  "selectDeliveryAddress": "Pilih alamat penghantaran",
  "totalOf": "Jumlah",
  "items": "item",
  "orderSummary": "Ringkasan pesanan",
  "paymentMethod": "Kaedah pembayaran",
  "Balance": "Seimbang",
  "payPal": "PayPal",
  "notOpen": "Kaedah pembayaran ini belum dibuka untuk wilayah anda",
  "mastercard": "MasterCard",
  "additional": "Tambahan",
  "handlingfee": "Caj perkhidmatan diperlukan",
  "goodsNumber": "Kuantiti produk",
  "deliveryFee": "Pengangkutan",
  "totalNum": "Jumlah",
  "new": "Baru",
  "oldPassword": "Kata laluan lama",
  "pleaseEnterOldPassword": "Sila masukkan kata laluan lama",
  "newPassword": "Kata laluan baharu",
  "plaseeEnterNewPassword": "Sila masukkan kata laluan baharu",
  "confirmPassword": "Sahkan kata laluan",
  "plaseeENterConfirmPassword": "Sila masukkan kata laluan pengesahan",
  "twoPawword": "Dua kata laluan tidak sama",
  "rechargeAddress": "Alamat cas semula",
  "plaseEnterRechargeAddress": "Sila masukkan alamat cas semula",
  "userCenter": "Pusat peribadi",
  "merchantSettled": "Kemasukan peniaga",
  "upNew": "Produk baru disenaraikan",
  "balanceNot": "Baki tidak mencukupi. Tolong cas semula.",
  "NoProductSelected": "Produk belum dipilih lagi",
  "ShippingAddressNotSet": "Alamat penghantaran tidak ditetapkan",
  "consigneeName": "Nama penerima",
  "email": "E-mel:",
  "areaCode": "Kod kawasan antarabangsa",
  "phoneNumber": "Nombor telefon",
  "nation": "Negara",
  "state": "Wilayah/Negeri/Negeri",
  "city": "Bandar",
  "postCode": "Poskod",
  "address": "Alamat terperinci",
  "addAddressOrModifyAddress": "Tambah alamat baharu/Ubah suai alamat",
  "setAsTheDefaultAddress": "Tetapkan sebagai alamat lalai",
  "proceed": "teruskan",
  "btnSure": "sahkan",
  "pleaseInput": "Sila masukkan",
  "allProduct": "Semua produk",
  "myCommodityCollection": "Produk kegemaran",
  "myFollowedShops": "Ikut kedai",
  "mySold": "terjual",
  "myPageviews": "Jumlah pelayaran",
  "myPraiseRate": "Kadar ulasan yang baik",
  "myUnfollow": "nyahikut",
  "inputNum": "Nombor",
  "inpuEmailErro": "Sila masukkan alamat e-mel yang betul",
  "goodsShip": "Penghantaran",
  "goodsShipTips": "Produk akan dihantar dalam masa 24 jam selepas membuat pesanan. Jika kawalan logistik wujud untuk pesanan berikut, pesanan mungkin ditangguhkan. Sila beri perhatian kepada maklumat logistik pesanan atau hubungi perkhidmatan pelanggan.",
  "goodsFreight": "Pengangkutan",
  "goodsFreeShipping": "Percuma",
  "goodsFreightTips1": "1. Komposisi pengangkutan produk merentas sempadan: tambang=yuran penghantaran+ tambang jarak jauh+ yuran penghantaran",
  "goodsFreightTips2": "2. Jika syarat pos tidak dipenuhi, tambang hendaklah dicaj mengikut syarat sebenar.",
  "goodsFreightTips3": "3. Hak tafsiran akhir adalah milik platform.",
  "pleaseValidPostCode": "Sila masukkan lebih daripada 4 digit",
  "pleaseValidEmail": "Sila masukkan alamat e-mel yang betul",
  "pleaseValidPhone": "Sila masukkan nombor telefon yang betul",
  "productAvailable": "Produk ini telah dikeluarkan",
  "validatorMaxNumber": "Jumlah melebihi had",
  "validatorRequire": "Item yang diperlukan tidak boleh batal",
  "validatorPhone": "Sila masukkan nombor telefon yang betul",
  "validatorEmail": "Sila masukkan format e-mel yang betul",
  "validatorPassword": "Kata laluan terdiri daripada 6-12 digit atau huruf(mengandungi watak istimewa)",
  "validatorSixNumber": "Sila masukkan 6 digit tulen",
  "validatorFourMoreNumber": "Sila masukkan gabungan 4-32 digit atau huruf",
  recommendclass:"Mengesyorkan Kategori",
  "加值": "Nilai tambah",
  "提领": "Pengeluaran",
  "平台人工发起退款": "Platform memulakan pemulangan wang secara manual",
  "银行卡": "Kad bank",
  "联系商家": "Hubungi peniaga",
  "滑动验证":"Sila geser untuk mengesahkan",
  "validatorIpRule": "Format IP yang salah",
  "validatorChineseAndEnglish": "Bahasa Cina dan Inggeris sahaja, masukkan julat: 8-64 aksara",
  "collectionSuccess": "Tambah ke kegemaran berjaya",
  "followedSuccess": "Ikuti berjaya",
  "cancelSuccess": "Dibatalkan berjaya",
  "evaluateOrder": "Semak dengan gambar",
  "evaluateOrderPlaceholder": "Sila semak produk",
  "operationSuccess": "Operasi berjaya",
  "confirmReceiveGoods": "Sahkan penerimaan produk atau tidak",
  "evaluateOrderSuccess": "Semakan berjaya",
  "yesterday": "Semalam",
  "notLogin": "Anda belum log masuk lagi.",
  "delAllHistoryRecord": "Adakah anda pasti mahu memadamkan semua rekod sejarah?",
  "or": "Ataupun",
  "tipsRemindsText": "Peniaga akan menerima peringatan selepas penghantaran diingatkan",
  "tipsRemindsCount": "Ia hanya boleh diingatkan sekali sahaja.",
  "tipsRemindsMerchant": "Ingatkan peniaga",
  "tipsRemindsSuccess": "Peringatan berjaya",
  "noCartTips": "Beg beli-belah anda kosong. Mulakan membeli-belah.",
  "defaultRate": "Sistem lalai kepada ulasan yang menggalakkan",
  "prevPage": "Halaman sebelumnya",
  "nextPage": "Muka surat seterusnya",
  "returnApply": "Permintaan bayaran balik",
  "returnReason": "Sebab bayaran balik",
  "returnAmount": "Jumlah pulangan",
  "returnRemark": "Arahan pulangkan",
  order: {
    confirm: "Sahkan resit",
    cancel: "Batalkan pesanan",
    payment: "Bayar sekarang",
    remind: "Ingatkan untuk Penghantaran",
    return: "Minta bayaran balik produk",
    evaluate: "Semak sekarang",
    logistics: "Lihat logistik",
    noRefund: "Tidak dibayar balik",
    refunding: "Bayaran balik sedang dijalankan",
    refundSuccess: "Bayaran balik berjaya",
    refundFail: "Bayaran balik gagal",
  },
  "remindTitle": "Ingatkan untuk Penghantaran",
  "remindContent": "Selepas penghantaran diingatkan, peniaga akan menerima peringatan tersebut. Ia hanya boleh diingatkan sekali sahaja.",
  "remindSuccess": "Peringatan berjaya",
  "remindRepeat": "Perintah ini telah diingatkan.",
  "noComments": "Tiada ulasan pada masa ini",
  "storeSeach": "Cari produk di kedai ini",
  "storeSeachTips1": "Ditemui untuk anda",
  "storeSeachTips2": "Kedai berkaitan ditemui",
  "storeSeachTips3": "Rumah",
  "creditTit": "Perkhidmatan kredit",
  "getCoupons": "Dapatkan lebih banyak kupon",
  "yourEmail": "alamat e-mel anda",
  "subscription": "Langganan",
  "paymethods": "Kaedah pembayaran",
  "footdec": "Pengguna tapak global {name} berasal dari {num} negara di seluruh dunia dan menggunakan {coin} untuk penyelesaian. {coin} ialah transaksi tanpa sempadan yang membolehkan transaksi kos rendah segera di seluruh dunia tanpa menunggu dan yuran antarabangsa.",
  "custService": "Khidmat Pelanggan",
  "helpLine": "Perkhidmatan pelanggan dalam talian",
  "contactUs": "Hubungi Kami",
  "partner": "Pembekal koperasi",
  "客户端下载": "Pelanggan untuk mengunduh",
  "提现方式": "Kaedah pengeluaran",
  "buyRules": "Peraturan pembeli",
  "sellerRules": "Dasar penjual",
  "returnsAndEx": "Pemulangan dan Pertukaran",
  "servicePolicy": "Dasar perkhidmatan",
  "returnPolicy": "Syarat pengembalian",
  "user_Center": "Pusat pengguna",
  "userReg": "Pendaftaran pengguna",
  "orderTrack": "Pertanyaan pesanan",
  "purchageHistory": "Sejarah pembelian",
  "myPurse": "Dompet saya",
  "aboutUs": "Tentang kita",
  "Recruitment": "Tunggu orang yang berbakat",
  "news": "Maklumat berita",
  "stateMent": "Kenyataan perhambaan moden",
  "binance": "Binance",
  "huobi": "Huobi",
  "okx": "okx",
  "metaMask": "MetaMask",
  "homeBannertips1": "Menjadi seorang peniaga",
  "homeBannertips2": "Jumlah komisen",
  "homeBannertips3": "Maks.",
  "homeBannerbtn": "Sertai sekarang",
  "homeDownloadtips1": "Pusat beli-belah borong e-dagang merentas sempadan",
  "homeDownloadtips2": "Tawaran istimewa jenama",
  "homeDownloadtips3": "Diskaun tanpa henti",
  "homeDownloadtips4": "muat turun Android",
  "homeDownloadtips5": "Muat turun Apple",
  "homeDownloadtips6": "Imbas kod QR untuk memuat turun APP",
  "homeIconTips1": "100% tulen",
  "homeIconTips2": "7 hari balik",
  "homeIconTips3": "Diskaun pengangkutan",
  "homeIconTips4": "Pembayaran selamat",
  "headerSearchTips": "Sila masukkan kata kunci untuk mencari",
  "collAccount": "Cara pinjaman",
  "mine": "saya.",
  "creditText1": "Pinjaman permulaan menyelesaikan masalah meminjam wang",
  "creditText2": "Menyediakan perkhidmatan pinjaman permulaan dan pusing ganti modal",
  "creditWorry": "Pinjaman tanpa kebimbangan",
  "creditQuota": "Had fleksibel",
  "creditQuotaINFO": "100,000 hingga 30,000,000 dengan had fleksibel dan tiada sekatan, dengan tempoh pinjaman maksimum setahun.",
  "quickLoan": "Pinjaman cepat",
  "creditReview": "Lulus audit dalam masa sejam paling awal, jika semakan lulus, pinjaman akan dikeluarkan dengan segera.",
  "safe": "Selamat dan tidak bimbang",
  "safeInfo": "Tiada gadai janji, tiada deposit, tiada panggilan balik, kerana ini sebenarnya adalah urusan peribadi.",
  "about": "Tentang kita",
  "aboutText1": "\"Kami komited untuk meminjamkan perkhidmatan kewangan, berdasarkan falsafah perniagaan \"\"diutamakan pelanggan\"\", memegang misi menyelesaikan masalah pusing ganti modal pelanggan. Sejak penubuhannya, syarikat telah membantu ramai pelanggan untuk menyelesaikan masalah pusing ganti modal.\"",
  "aboutText2": "Had: 100,000-30,000,000, kaedah pembayaran balik yang fleksibel dengan faedah rendah, tiada yuran pendahuluan, pinjaman dalam talian, tiada panggilan telefon untuk pengesahan, maklumat sulit dan pinjaman hari yang sama.",
  "contactUs1": "Jika anda tidak mahu meminjam wang daripada rakan setingkat anda, sila hubungi kami.",
  "committed": "Komited dengan perkhidmatan pinjaman usahawan",
  "financial": "Atasi masalah kewangan anda",
  "partnersTit": "Platform Pinjaman Dalam Talian Rakan Kongsi",
  "application": "Permohonan pinjaman",
  "applicant": "Pemohon",
  "actualName": "Nama sebenar",
  "yourName": "Sila masukkan nama",
  "term": "Tempoh pinjaman",
  "applicationAmount": "Jumlah yang diminta",
  "rates": "Kadar faedah pinjaman",
  "loanMethod": "Cara pinjaman",
  "accountB": "Baki akaun",
  "countryOf": "kewarganegaraan",
  "myloan": "pinjaman saya",
  "applyLoan": "Mohon pinjaman",
  "loaned": "Dipinjamkan",
  "interest": "Faedah terakru",
  "esRepayment": "Anggaran bayaran balik",
  "loanHistory": "Rekod pinjaman",
  "applicantDate": "Tarikh permohonan",
  "repayment": "Bayaran balik",
  "cycle": "Kitaran pembayaran balik",
  "fixedRate": "Kadar faedah tetap",
  "successLoan": "Pinjaman berjaya",
  "Reapply": "Mohon semula",
  "borrow": "Pinjaman gagal",
  "applicantIn": "Permohonan sedang dijalankan",
  "repaid": "Bayaran balik",
  "overdue": "Tertunggak",
  "estirepay": "Anggaran bayaran balik",
  "loanDays": "Bilangan hari dipinjamkan",
  "reAmount": "Jumlah bayaran balik",
  "repay": "Mod pembayaran balik",
  "entRepay": "Sahkan pembayaran balik",
  "foryourmoney": "Sekiranya anda kekurangan dana, tidak mencari tempat untuk meminjam wang atau malu untuk meminjam wang daripada rakan anda, anda boleh menghubungi kami. Kami mempunyai keseluruhan proses perkhidmatan profesional untuk menjawab keraguan anda pada bila-bila masa. Matlamat kami adalah untuk menjadikan setiap pinjaman telus, supaya pelanggan boleh menggunakannya dengan cepat dan yakin.",
  "onlineApplin": "Mohon dalam talian",
  "businessloan": "Permohonan untuk pinjaman permulaan",
  "selectCountry": "Sila pilih kewarganegaraan",
  "selectPeriod": "Sila pilih tempoh",
  "passPortImg": "No. ID/No. Pasport",
  "uploadId": "Muat naik gambar sijil/pasport",
  "readAndAgree": "Saya telah membaca dan bersetuju",
  "loanAgree": "Perjanjian pinjaman",
  "submitApplica": "Penyerahan permohonan",
  "photoExample": "Contoh mengambil gambar",
  "discounted": "Produk diskaun",
  "days": "hari",
  "privacyPolicy": "Dasar privasi",
  "delivery": "Penghantaran dan pengambilan",
  "checkAgreement": "Sila tandakan perjanjian!",
  "businessPhone": "Telefon bisnes",
  "businessEmail": "E-mel Korporat",
  "最多上传9张图片": "Maksimum 9 gambar",
  "账号注销": "Log keluar",
  "确定注销": "Log keluar",
  "您的账号": "Akaun anda",
  "企业电话": "Telefon bisnes",
  "职业机会": "Kemungutan pekerjaan",
  "最多包含10位小数": "Maksimum 10 titik perpuluhan",
  "为什么要离开": "Kenapa anda perlu meninggalkan?",
  "您还有余额,不能注销账号": "Anda masih mempunyai baki, tidak boleh log keluar!",
  "长时间未付款，系统自动取消订单": "Pesanan dibatalkan secara automatik kerana tidak dibayar dalam masa yang lama",
  "请输入注销理由": "Sila masukkan sebab log keluar",
  "您确认要注销吗?": "Anda pasti ingin log keluar?",
  "我再考虑下": "Batal",
  "同意注销": "Log keluar",
  "注销成功": "Log keluar berjaya",
  "暂无店铺": "Tiada kedai",
  "App下载(买家端)": "Muat turun aplikasi (pelanggan)",
  "App下载(卖家端)": "Muat turun aplikasi (penjual)",
  "加密货币": "Mata wang digital",
  '参数缺失': "Parameter yang hilang",
  '充值数量必填': "Jumlah topup diperlukan",
  "银行卡": "Kad bank",
  "充值币种": "Mata wang topup",
  "充值金额": "Jumlah topup",
  "充值金额不得小于": "Jumlah topup tidak boleh kurang daripada",
  "充值金额不得大于": "Jumlah topup tidak boleh melebihi",
  "请先选择币种": "Sila pilih mata wang terlebih dahulu",
  "开户行": "Nama bank",
  "请输入开户行名称": "Sila masukkan nama bank",
  "银行卡号": "Nombor kad bank",
  "请输入银行卡号": "Sila masukkan nombor kad bank",
  "点击去支付": "Klik untuk membayar",
  "企业证明": "Sijil syarikat",
  footTipTikTok:'CoveBuy ©️2024 Hak Cipta',
  TikTokFoot:'CoveBuy ialah platform sosial video pendek global CoveBuy dan syarikat perdagangan borong terbesar di Asia Alibaba, ditubuhkan dengan kerjasama. Ia ialah platform e-dagang global dan mempunyai tiga gudang pintar yang dikendalikan sendiri di dunia, terletak di Toronto, Kanada, Los Angeles dan Chiba, Jepun. Produk yang dijual dalam apl termasuk produk popular dari Jepun, Korea Selatan, China dan negara Asia yang lain. Pada masa ini, jumlahnya telah melebihi 50,000 dan terus berkembang pesat.',
  "cancelInfo":"amaran! Sila berhati-hati untuk membatalkan akaun. Jika anda tidak lagi menggunakan akaun, anda boleh mengklik [Setuju untuk Pembatalan]. Anda mungkin tidak dapat mendaftar dalam masa beberapa hari selepas pembatalan.",
  "betaBannerText": "Laman web dalam ujian awam, sila jangan buat pesanan"
}